// extracted by mini-css-extract-plugin
export default {"siteloader":"siteloader_siteloader__bVrH+","main":"siteloader_main__fMf2l","center":"siteloader_center__7rP6e","middle":"siteloader_middle__aH9ZM","top":"siteloader_top__5kFPU"};